import { Chart, Plugin } from 'chart.js'

const crosshairPlugin: Plugin = {
  id: 'crosshair',
  afterDraw(chart: Chart) {
    const { tooltip, chartArea, ctx } = chart
    if (!tooltip?.getActiveElements().length) return

    const x = tooltip.getActiveElements()[0].element.x

    ctx.save()
    ctx.beginPath()
    ctx.setLineDash([4, 4])
    ctx.strokeStyle = '#e0e0e0'
    ctx.lineWidth = 1
    ctx.moveTo(x, chartArea.top)
    ctx.lineTo(x, chartArea.bottom)
    ctx.stroke()
    ctx.restore()
  }
}

export default crosshairPlugin
